import React, { useState, useEffect } from 'react';
import './App.css';
import Header from './components/Header/Header';
import Hero from './components/Hero/Hero';
import About from './components/About/About';
import Team from './components/Team/Team';
import Services from './components/Services/Services';
import Account from './components/Account/Account';
import Contact from './components/Contact/Contact';
import Footer from './components/Footer/Footer';
import LoadingScreen from './components/LoadingScreen/LoadingScreen';
import LoginSignup from './components/LoginSignup/LoginSignup';

function App() {
  const [scrollY, setScrollY] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const [showLogin, setShowLogin] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrollY(window.scrollY);
    window.addEventListener('scroll', handleScroll);
    
    // Always scroll to top when component mounts or updates
    window.scrollTo(0, 0);
    
    return () => window.removeEventListener('scroll', handleScroll);
  }, [showLogin]); // Re-run when showLogin changes

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const handleLoginClick = () => {
    setShowLogin(true);
    // Scroll to top when opening login page
    window.scrollTo(0, 0);
  };

  const handleBackToHome = () => {
    setShowLogin(false);
    // Scroll to top when returning to home
    window.scrollTo(0, 0);
  };

  // Loading screen removed

              if (showLogin) {
                return (
                  <div className="app">
                    <Header 
                      scrollY={scrollY} 
                      scrollToSection={scrollToSection} 
                      handleLoginClick={handleLoginClick}
                      isLoginPage={true}
                      handleBackToHome={handleBackToHome}
                    />
                    <main className="main-content">
                      <LoginSignup handleBackToHome={handleBackToHome} />
                    </main>
                    <Footer handleLoginClick={handleLoginClick} />
                  </div>
                );
              }

  return (
    <div className="app">
      <Header scrollY={scrollY} scrollToSection={scrollToSection} handleLoginClick={handleLoginClick} />
      <main className="main-content">
        <section id="home">
          <Hero handleLoginClick={handleLoginClick} />
        </section>
        <section id="about">
          <About />
        </section>
        <section id="team">
          <Team />
        </section>
        <section id="account">
          <Services handleLoginClick={handleLoginClick} />
        </section>
        <section id="contact">
          <Contact />
        </section>
      </main>
      <Footer handleLoginClick={handleLoginClick} />
    </div>
  );
}

export default App;